import { ProdutoCodbarPopupComponent } from './../produto-codbar-popup/produto-codbar-popup.component';
import { FatClassFiscalService } from './../../../../../shared/services/fat-class-fiscal.service';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Cidade } from '../../../../../shared/interfaces/cidade';
import { Endereco } from '../../../../../shared/interfaces/endereco';
import { GrupoProdutos } from '../../../../../shared/interfaces/grupo-produtos';
import { Marca } from '../../../../../shared/interfaces/marca';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Produto } from '../../../../../shared/interfaces/produto';
import { ProdutoMovto } from '../../../../../shared/interfaces/produto-movto';
import { UnMedida } from '../../../../../shared/interfaces/un-medida';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { JwtAuthService } from '../../../../../shared/services/auth/jwt-auth.service';
import { FatClassTipiService } from '../../../../../shared/services/fat-class-tipi.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { MarcaService } from '../../../../../shared/services/marca.service';
import { ProdutoGrupoService } from '../../../../../shared/services/produto-grupo.service';
import { ProdutoUnMedidaService } from '../../../../../shared/services/produto-un-medida.service';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LancamentoDetailsComponent } from '../../../../../views/movimentacao/faturamento/lancamento/lancamento-details/lancamento-details.component';
import { ClassificacaoGerencialService } from '../../../../../shared/services/classificacao-gerencial.service';
// tslint:disable-next-line:max-line-length
import { BehaviorSubject, Observable, Subscription, Subject, Subscriber } from 'rxjs';
import { debounceTime, finalize, switchMap, tap, filter, takeUntil, map, delay } from 'rxjs/operators';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { ProdutoMovtoPopupComponent } from '../produto-movto-popup/produto-movto-popup.component';
import { ProdutoTribPopupComponent } from '../produto-trib-popup/produto-trib-popup.component';
import { ProdutoPrecoPopupComponent } from '../produto-preco-popup/produto-preco-popup.component';
import { ProdutoImagesPopupComponent } from '../produto-images-popup/produto-images-popup.component';
import { ProdutoEnums } from '../../../../../shared/interfaces/produto-enums';
import { ProdutoAnexoUploadListComponent } from '../produto-anexo-upload-list/produto-anexo-upload-list.component';
import { AutomBombaService } from '../../../../../shared/services/autom-bomba .service';
import { AutomBomba } from '../../../../../shared/interfaces/autom-bomba';
import { ClassificacaoGerencial } from '../../../../../shared/interfaces/classificacao-gerencial';

@Component({
  selector: 'app-produto-details',
  templateUrl: './produto-details.component.html',
  styleUrls: ['./produto-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class ProdutoDetailsComponent implements OnInit {

  layoutConf: any;

  public hasBaseDropZoneOver = false;
  dialogRef: MatDialogRef<any>;
  itemForm: FormGroup;

  itemFormSub: Subscription;
  itemDiretivasFatForm: FormGroup;
  produtoCodigo: number;
  produto: Produto;
  grupo: GrupoProdutos;

  showEditOption = true;
  filtroCidades: Cidade[] = [];
  cidades: Cidade[];


  public searching = false;
  protected _onDestroy = new Subject<void>();

  isLoadingFatMarca: boolean;
  fatMarcas: Marca[] = [];
  fatMarca: Marca;

  isLoadingCadUnidade1 = false;
  unidades$: BehaviorSubject<UnMedida[]> = new BehaviorSubject<UnMedida[]>([]);
  cadUnidade1: UnMedida;
  isLoadingCadUnidade2: boolean;
  cadUnidade2: any;
  isLoadingCadUnidade3: boolean;
  cadUnidade3: any;
  isLoadingCadUnidade4: boolean;
  cadUnidade4: any;
  isLoadingCadUnidadePadraoVenda: boolean;
  cadUnidadePadraoVenda: any;
  isLoading = false;
  isLoadingGrupo = false;
  grupos: GrupoProdutos[] = [];
  automBombas: AutomBomba[] = [];
  public medidas: UnMedida[] = [];
  selectedTabIndex = 0;
  errorMsg: string;

  isLoadingClassGerencial = false; 
  classificacoesGerenciais$: BehaviorSubject<ClassificacaoGerencial[]> = new BehaviorSubject<ClassificacaoGerencial[]>([]); 
  classificacaoGerencial: ClassificacaoGerencial; 

  countDown: Subscription;

  counter = 20;
  tick = 1000;


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatPaginator, { static: false }) paginatorEndereco: MatPaginator;


  pageObject$: BehaviorSubject<PageResult<ProdutoMovto>> = new BehaviorSubject<PageResult<ProdutoMovto>>(null);
  movtos: ProdutoMovto[];
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25];

  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';

  pageObjectEndereco$: BehaviorSubject<PageResult<Endereco>> = new BehaviorSubject<PageResult<Endereco>>(null);
  public enderecos: Endereco[];
  pageEndereco = 1;
  lengthEndereco = 0;
  pageSizeEndereco = 5;
  pageEventEndereco = null;
  pageSizeOptionsEndereco: number[] = [5, 10, 25];

  enums: ProdutoEnums;
  dialogRefTrib: MatDialogRef<any>





  maskFone = { mask: '(00) {*}0000-0000', lazy: true, placeholderChar: '_' };
  maskCep = { mask: '00000-000', lazy: true, placeholderChar: '_' };
  maskCpf = { mask: '000.000.000-00', lazy: true, placeholderChar: '_' };
  maskCnpj = { mask: '00.000.000/0000-00', lazy: true, placeholderChar: '_' };
  maskUpper = { mask: /^\w\s*/, prepare: (str: any) => str.toUpperCase() };
  maskLower = { mask: /^\w\s*/, prepare: (str: any) => str.toLowerCase() };
  maskEmail = { mask: /^\S*@?\S*$/, prepare: (email: any) => email.toLowerCase() };
  maskCodigoBarra = { mask: '0000000000000{*}', lazy: true, placeholderChar: '_' };
  maskData = { mask: '00/00/0000', lazy: true, placeholderChar: '_' };

  cnpjReceitaWsResult: any = null;
  cnpjReceitaResult: any = null;
  cnpjReceitaResult2: any;
  cnpjReceitaResult3: Object;
  cnpjReceitaWsResult2: string;
  produtoSelected: Produto;





  oldIndex: number;

  locationUrl = '/produto_detail/';
  changeLocationUrl = this.locationUrl;
  isSaving: boolean;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRefProdutoDetail: MatDialogRef<ProdutoDetailsComponent>,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private produtoService: ProdutoService,
    private automBombaService: AutomBombaService,
    public jwtAuthService: JwtAuthService,
    private grupoService: ProdutoGrupoService,
    private unMedidaService: ProdutoUnMedidaService,
    private fatMarcaService: MarcaService,
    private fatClassTipiService: FatClassTipiService,
    private fatClassFiscalService: FatClassFiscalService,
    private fatDoctoCService: FatDoctoCService,
    private loader: AppLoaderService,
    private confirmService: AppConfirmService,
    private cdr: ChangeDetectorRef,
    private layout: LayoutService,
    private classificacaoGerencialService: ClassificacaoGerencialService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Verifica se o componente foi chamado como popup
    // if (this.data) {
    //   this.produto = this.data.produto;
    // }
  }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    
    // Verifica se o componente foi chamado como popup
    if (this.data?.produto?.id) {
      // Chamado como popup
      console.log('Chamado como popup');
      this.produtoCodigo = this.data.produto.codigo;
      console.log(`produtoCodigo: ${this.produtoCodigo}`);
    } else {
      // Chamado pela rota
      console.log('Chamado pela rota');
      this.produtoCodigo = this.route.snapshot.params['codigo'];
    }
    
    this.showEditOption = true; // Permite edição no popup
    this.selectedTabIndex = this.route.snapshot.params['tabIndex'] ?? 0;

    // Carrega dados necessários para o formulário
    this.grupoService.getProdutoGrupoPage(1, 10).subscribe(grupos => this.grupos = grupos.content);
    this.fatMarcaService.getMarcaPage(1, 10).subscribe(marcas => this.fatMarcas = marcas.content);
    this.unMedidaService.getUnMedidaList().subscribe(uns => this.medidas = uns);
    this.produtoService.getEnums().subscribe(enums => {
      this.enums = enums;
      console.log(`tipo produto Autom... ${JSON.stringify(this.enums.tipoProdutoAutom)}`);
    });

    this.automBombaService.getombaPage(1, 10).subscribe(bombas => {
      this.automBombas = bombas.content;
      console.log(`bombas... ${JSON.stringify(this.automBombas)}`);
    });

    this.buildProdutoForm(this.produto);

    console.log(`passei pelo buildProdutoForm...`);

    if (this.produtoCodigo) {
      this.getProduto();
      this.showEditOption = false; // Desabilita edição se chamado pela rota
    } else {
      this.createProduto();
      this.showEditOption = true; // Permite edição para novos produtos
    }


    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.movtos = page.content;
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          if (this.page === 1) {
            this.paginator.firstPage();
          }
        } else {
          this.movtos = [];
        }
      });



    // Listener para Classificação Gerencial
    this.itemForm.get('searchClassificacaoGerencial')?.valueChanges
    .pipe(
      filter(search => !!search),
      tap(() => this.searching = true),
      takeUntil(this._onDestroy),
      debounceTime(200),
      map(search => {
        return this.classificacaoGerencialService.getClassificacaoGPageSearch(1, 10, search).subscribe(classificacoes => {
          this.classificacoesGerenciais$.next(classificacoes.content);
        });
      }),
      delay(500),
      takeUntil(this._onDestroy)
    )
    .subscribe(() => {
      this.searching = false;
      this.selectClassificacaoGerencial();
    },
    error => {
      this.searching = false;
      this.confirmService.confirm({
        message: `A T E N Ç Ã O ! ERRO PESQUISANDO CLASSIFICAÇÃO GERENCIAL ... ${error}`,
        error: true
      });
    });
      

    //listen for search Autom Bomba
    this.itemForm.get('searchAutomBomba')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.automBombas) {
            return [];
          }
          return this.automBombaService.getBombaPageSearch(1, 10, search).subscribe(bombas => {
            this.automBombas = bombas.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        if (this.produto.automBomba !== undefined && this.produto.automBomba !== null) {
          this.automBombas.push(this.produto.automBomba);
        }
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO CADASTRO DE BOMBAS ... ${error}`,
              error: true
            });
        });


    //listen for search Grupo
    this.itemForm.get('searchGrupo')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.grupos) {
            return [];
          }
          return this.grupoService.getProdutoGrupoPageSearch(1, 10, search).subscribe(grupos => {
            this.grupos = grupos.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        if (this.produto.fatGrupoprodutos !== undefined && this.produto.fatGrupoprodutos !== null) {
          this.grupos.push(this.produto.fatGrupoprodutos);
        }
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO GRUPO/CATEGORIA ... ${error}`,
              error: true
            });
        });


    //listen for search Marca
    this.itemForm.get('searchMarca')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.fatMarcas) {
            return [];
          }
          return this.fatMarcaService.getMarcaPageSearch(1, 10, search).subscribe(fatMarcas => {
            this.fatMarcas = fatMarcas.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        if (this.produto.fatMarca !== undefined && this.produto.fatMarca !== null) {
          this.fatMarcas.push(this.produto.fatMarca);
        }
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO MARCA ... ${error}`,
              error: true
            });
        });



    this.itemForm.get('searchUnidade1')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          // if (!this.unidades) {
          //   return [];
          // }
          return this.unMedidaService.getUnMedidaPageSearch(1, 10, search).subscribe(un => {
            this.unidades$.next(un.content);

          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        this.selectCadUnidade1();

      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`,
              error: true
            });
        });

    this.itemForm.get('searchUnidade2')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          // if (!this.unidades) {
          //   return [];
          // }
          return this.unMedidaService.getUnMedidaPageSearch(1, 10, search).subscribe(un => {
            this.unidades$.next(un.content);

          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        this.selectCadUnidade2();

      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`,
              error: true
            });
        });

    this.itemForm.get('searchUnidade3')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          // if (!this.unidades) {
          //   return [];
          // }
          return this.unMedidaService.getUnMedidaPageSearch(1, 10, search).subscribe(un => {
            this.unidades$.next(un.content);

          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        this.selectCadUnidade3();

      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`,
              error: true
            });
        });

    this.itemForm.get('searchUnidade4')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          // if (!this.unidades) {
          //   return [];
          // }
          return this.unMedidaService.getUnMedidaPageSearch(1, 10, search).subscribe(un => {
            this.unidades$.next(un.content);

          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        this.selectCadUnidade4();

      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`,
              error: true
            });
        });

    this.itemForm.get('cadUnidadePadraoVenda')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          // if (!this.unidades) {
          //   return [];
          // }
          return this.unMedidaService.getUnMedidaPageSearch(1, 10, search).subscribe(un => {
            this.unidades$.next(un.content);

          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(s => {
        this.searching = false;
        this.selectCadUnidadePadraoVenda();

      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`,
              error: true
            });
        });

  }


  private selectClassificacaoGerencial() {
    if (this.produto?.classificacaoGerencial) {
      const currentClassificacoes = this.classificacoesGerenciais$.value;
      if (currentClassificacoes.map(c => c.id).includes(this.produto.classificacaoGerencial.id)) {
        const classificacao = currentClassificacoes.find(c => c.id === this.produto.classificacaoGerencial.id) ?? this.produto.classificacaoGerencial;
        if (classificacao) {
          this.itemForm.controls['classificacaoGerencial'].setValue(classificacao);
        }
      } else {
        currentClassificacoes.push(this.produto.classificacaoGerencial);
        this.classificacoesGerenciais$.next(currentClassificacoes);
        this.itemForm.controls['classificacaoGerencial'].setValue(this.produto.classificacaoGerencial);
      }
    }
  }


  private selectCadUnidade1() {
    if (this.produto.cadUnidade1 !== undefined && this.produto.cadUnidade1 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade1.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade1.id) ?? this.produto.cadUnidade1;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade1'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade1);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidade2() {
    if (this.produto.cadUnidade2 !== undefined && this.produto.cadUnidade2 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade2.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade2.id) ?? this.produto.cadUnidade2;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade2'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade2);
        this.unidades$.next(uns);
      }
    }
  }


  private selectCadUnidade3() {
    if (this.produto.cadUnidade3 !== undefined && this.produto.cadUnidade3 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade3.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade3.id) ?? this.produto.cadUnidade3;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade3'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade3);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidade4() {
    if (this.produto.cadUnidade4 !== undefined && this.produto.cadUnidade4 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade4.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade4.id) ?? this.produto.cadUnidade4;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade4'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade4);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidadePadraoVenda() {
    if (this.produto.cadUnidadePadraoVenda !== undefined && this.produto.cadUnidadePadraoVenda !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidadePadraoVenda.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidadePadraoVenda.id) ?? this.produto.cadUnidadePadraoVenda;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidadePadraoVenda'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidadePadraoVenda);
        this.unidades$.next(uns);
      }
    }
  }



  private changeUrl() {
    this.changeLocationUrl = this.locationUrl + this.produto?.id + '/' + this.selectedTabIndex;
  }

  // ngOnDestroy() {
  //   this.document.body.classList.remove('print-body-content');
  // }

  createProduto() {
    this.produtoService.create().subscribe((produto) => {
      this.produto = produto;
      // this.buildProdutoForm(this.produto);
      this.cdr.markForCheck();
    });
  }

  getProduto() {
    this.loader.open();
    this.produtoService.getProdutoById(this.produtoCodigo).subscribe((produto) => {
      this.produto = produto;
      this.changeUrl();


      this.cdr.markForCheck();

      console.log('dentro do getprpduto');

      this.buildProdutoForm(this.produto);

      this.itemForm.controls['tipo'].setValue(this.produto.tipo)


      this.automBombas.push(this.produto.automBomba);
      this.itemForm.controls['automBomba'].setValue(this.produto?.automBomba);

      // this.itemForm.controls['tipoProdutoAutom'].setValue(this.produto?.tipoProdutoAutom);

      this.grupos.push(this.produto.fatGrupoprodutos);
      this.itemForm.controls['fatGrupoprodutos'].setValue(this.produto.fatGrupoprodutos)

      console.log('dentro do getprpduto 2');

      this.fatMarcas.push(this.produto.fatMarca);
      this.itemForm.controls['fatMarca'].setValue(this.produto.fatMarca);
      this.unMedidaService.getUnMedidaPage(1, 10).subscribe(un => {
        this.unidades$.next(un.content);
        this.selectCadUnidade1();
        this.selectCadUnidade2();
        this.selectCadUnidade3();
        this.selectCadUnidade4();
        this.selectCadUnidadePadraoVenda();
      });

      // Garantir que classificações gerenciais estejam carregadas antes de selecionar
      this.classificacaoGerencialService.getClassificacaoGPage(1, 10).subscribe(classificacoes => {
        this.classificacoesGerenciais$.next(classificacoes.content);
        this.selectClassificacaoGerencial();
      });

    }, er => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR PRODUTO: ${er.error.status}`, error: true })
        .subscribe(_ => this.router.navigateByUrl('produto_detail/list'));
    }, () => {
      this.loader.close();


    });

  }


  buildProdutoForm(produto: Produto) {
    this.produtoSelected = produto;
    this.itemForm = this.fb.group({
      id: [produto?.id],
      codigo: [produto?.codigo],
      uuid: [produto?.uuid],
      desativado: [produto?.desativado],
      descricao: [produto?.descricao, [Validators.required]],
      fatGrupoprodutos: [produto?.fatGrupoprodutos, [Validators.required]],
      referencia: [produto?.referencia],
      localizacao: [produto?.localizacao],
      fatMarca: [produto?.fatMarca, [Validators.required]],
      cadUnidade1: [produto?.cadUnidade1, [Validators.required]],
      cadUnidadePadraoVenda: [produto?.cadUnidadePadraoVenda, [Validators.required]],
      cadUnidade2: [produto?.cadUnidade2],
      cadUnidade3: [produto?.cadUnidade3],
      cadUnidade4: [produto?.cadUnidade4],
      // unidadepadraovenda: [item?.unidadepadraovenda, [Validators.required]],
      classificacaoGerencial: [produto?.classificacaoGerencial],
      fatProdutoSaldo: [produto?.fatProdutoSaldo],
      codigoanp: [produto?.codigoanp],
      codigobarra1: [produto?.codigobarra1],
      codigobarra2: [produto?.codigobarra2],
      codigobarra3: [produto?.codigobarra3],
      codigobarra4: [produto?.codigobarra4],
      combNumeroBico: [produto?.combNumeroBico],
      combNumeroTanque: [produto?.combNumeroTanque],
      comissaoAliqPrazo: [produto?.comissaoAliqPrazo],
      comissaoAliqVista: [produto?.comissaoAliqVista],
      complemento: [produto?.complemento],

      dadosadicionais: [produto?.dadosadicionais],
      dadosadicionaisAsHtml: true,
      dataalteracao: [produto?.dataalteracao],
      datainclusao: [produto?.datainclusao],
      dataultimocusto: [produto?.dataultimocusto],
      fatorunidade1: [produto?.fatorunidade1],
      fatorunidade2: [produto?.fatorunidade2],
      fatorunidade3: [produto?.fatorunidade3],
      horaalteracao: [produto?.horaalteracao],
      horainclusao: [produto?.horainclusao],
      indIncentivo: [produto?.indIncentivo],
      indIss: [produto?.indIss],
      marca: [produto?.marca],

      ncmAliqImp: [produto?.ncmAliqImp],
      ncmAliqNac: [produto?.ncmAliqNac],
      ncmEx: [produto?.ncmEx],
      ncmTabela: [produto?.ncmTabela],
      percentualIpi: [produto?.percentualIpi],
      pesobruto: [produto?.pesobruto],
      pesoliquido: [produto?.pesoliquido],
      tipo: [produto?.tipo],
      ultimocusto: [produto?.ultimocusto],
      usuarioalteracao: [produto?.usuarioalteracao],
      usuarioinclusao: [produto?.usuarioinclusao],
      volume: [produto?.volume],
      fcpAliquota: [produto?.fcpAliquota],
      fcpSubstAliquota: [produto?.fcpSubstAliquota],
      fcpSubstAnteriorAliquota: [produto?.fcpSubstAnteriorAliquota],
      codigoBarraBalanca: [produto?.codigoBarraBalanca],
      layoutEtiquetaBalanca: [produto?.layoutEtiquetaBalanca],
      codigoMlb: [produto?.codigoMlb],
      categoryMlb: [produto?.categoryMlb],
      stopTimeMlb: [produto?.stopTimeMlb],
      produtoNovo: [produto?.produtoNovo],
      potencia: [produto?.potencia],
      cilindrada: [produto?.cilindrada],
      capacidadeMaximaTracao: [produto?.capacidadeMaximaTracao],
      distanciaEntreEixos: [produto?.distanciaEntreEixos],
      tipoVeiculo: [produto?.tipoVeiculo],
      especieVeiculo: [produto?.especieVeiculo],
      condicaoChassi: [produto?.condicaoChassi],
      condicao: [produto?.condicao],
      lotacao: [produto?.lotacao],
      bomba: [produto?.bomba],
      diluicao: [produto?.diluicao],
      indiceExpansao: [produto?.indiceExpansao],
      pphp: [produto?.pphp],

      cadastroParticipante: [produto?.cadastroParticipante],
      fatTabelaMedida: [produto?.fatTabelaMedida],
      fatGrupoprodutosUUID: [produto?.fatGrupoprodutosUUID],
      saldo: [produto?.saldo],
      prazoEntrega: [produto?.prazoEntrega],
      largura: [produto?.largura],
      altura: [produto?.altura],
      profundidade: [produto?.profundidade],
      tipoProdutoAutom: [produto?.tipoProdutoAutom],
      automBomba: [produto?.automBomba],
      searchUnidade1: '',
      searchUnidade2: '',
      searchUnidade3: '',
      searchUnidade4: '',
      searchUnidadePadrao: '',
      searchGrupo: [""],
      searchMarca: [""],
      searchAutomBomba: [""],
      searchClassificacaoGerencial: [''],
    });


    if (this.itemFormSub) {
      this.itemFormSub.unsubscribe();
    }

  }



  save(): BehaviorSubject<Produto | null> {
    if (this.itemForm.invalid) {
      this.validateAllFormFields(this.itemForm);
      this.snack.open('Por favor, preencha todos os campos obrigatórios!', 'OK', { duration: 5500 });
      return new BehaviorSubject<Produto | null>(null);
    }
    const result = new BehaviorSubject<Produto | null>(null);
    this.produtoService.saveOrUpdate(this.itemForm.value).subscribe(
      val => {
        console.log(`salvou... ${JSON.stringify(val)}`);
        console.log(`classificacao... ${JSON.stringify(this.itemForm.value.classificacaoGerencial)}`);
        // this.snack.open('SALVO COM SUCESSO!', 'OK', { duration: 5500 });
        this.confirmService.confirm({
          title: 'S U C E S S O !',
          icon: 'check_circle',
          message: 'OK, PRODUTO SALVO COM SUCESSO !', error: false
        });
        result.next(val);
      },
      err => {
        // this.snack.open(`ERRO AO SALVAR: ${err}`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          icon: 'error',
          title: 'A T E N Ç Ã O !',
          message: `A T E N Ç Ã O ! ERRO AO SALVAR PRODUTO: ${err.error.status}`,
          error: true
        });
      }
    );
    return result;
  }
  // onFocusGrupo() {
  //   this.itemForm.get('fatGrupoprodutos').valueChanges
  //     .pipe(
  //       debounceTime(500),
  //       tap(() => this.isLoadingGrupo = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.grupoService.getProdutoGrupoPageSearch(1, 10, value) :
  //           this.grupoService.getProdutoGrupoPage(1, 10)) : new Observable<PageResult<GrupoProdutos>>())
  //         .pipe(
  //           finalize(() => this.isLoadingGrupo = false),
  //         )
  //       )
  //     )
  //     .subscribe(grupos => this.grupos = grupos.content);
  // }

  // onSelectionChangeGrupo(event: any): void {
  //   if (event.option.value !== undefined) {
  //     this.grupo = event.option.value;
  //   }
  // }

  // displayFnGrupo(grupo: GrupoProdutos) {
  //   if (grupo) {
  //     return `${grupo.id} - ${grupo.descricao.trim()}`;
  //   }
  // }

  // onFocusFatMarca() {
  //   this.itemForm.get('fatMarca').valueChanges
  //     .pipe(
  //       debounceTime(500),
  //       tap(() => this.isLoadingFatMarca = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.fatMarcaService.getMarcaPageSearch(1, 10, value) :
  //           this.fatMarcaService.getMarcaPage(1, 10)) : new Observable<PageResult<Marca>>())
  //         .pipe(
  //           finalize(() => this.isLoadingFatMarca = false),
  //         )
  //       )
  //     )
  //     .subscribe(fatMarcas => this.fatMarcas = fatMarcas.content);
  // }

  // onSelectionChangeFatMarca(event: any): void {
  //   if (event.option.value !== undefined) {
  //     this.fatMarca = event.option.value;
  //   }
  // }

  // displayFnFatMarca(fatMarca: Marca) {
  //   if (fatMarca) {
  //     return `${fatMarca.id} - ${fatMarca.descricao.trim()}`;
  //   }
  // }

  // addFatMarca() {
  //   console.log('Adiciona Marca');
  // }





  onSelectionChangeCadUnidade1(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade1 = event.value;
    }
  }




  onFocusCadUnidade2() {
    this.itemForm.get('cadUnidade2').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade2 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade2 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade2(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade2 = event.value;
    }
  }

  onFocusCadUnidade3() {
    this.itemForm.get('cadUnidade3').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade3 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade3 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade3(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade3 = event.value;
    }
  }

  onFocusCadUnidade4() {
    this.itemForm.get('cadUnidade4').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade4 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade4 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade4(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade4 = event.value;
    }
  }

  onFocusCadUnidadePadraoVenda() {
    this.itemForm.get('cadUnidadePadraoVenda').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidadePadraoVenda = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidadePadraoVenda = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidadePadraoVenda(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidadePadraoVenda = event.value;
    }
  }




  addGrupo() {
  }



  openLcto(controle: number) {
    this.loader.open();
    this.fatDoctoCService.getFatDoctoC(controle).subscribe(val => {
      this.openPopUp(val);
      this.loader.close();
    }, ee => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${ee}`, error: true })
    }, () => {
      this.loader.close();
    });
  }

  openPopUp(data: any = {}) {

    this.dialogRef = this.dialog.open(LancamentoDetailsComponent, {
      height: '100%',
      disableClose: false
    });
    this.dialogRef.componentInstance.lcto = data;


    if (this.dialogRef) {
      this.dialogRef.disableClose = true;
      this.dialogRef.backdropClick().subscribe(_ => {
        if (this.dialog.openDialogs.length > 0) {
          const cn = confirm('Deseja realmente sair ?')
          if (cn) {
            this.dialogRef.close();
          }
        }
      })
    }

    this.dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.fatDoctoCService.saveOrUpdate(res)
          .subscribe(() => {
            this.loader.close();
            this.snack.open('Registro salvo com sucesso!', 'OK', { duration: 5500 })
          }, () => {
            this.loader.close();
            this.snack.open('Erro ao salvar o Registro!', 'ERRO', { duration: 5500 });
          })
      })
  }

  close() {
    if (this.data?.produto?.id) {
      this.dialogRefProdutoDetail.close()
    } else {
      this.router.navigateByUrl('/produto_detail/list');
    }
  }

  print() {
    window.print();
  }


  /**
   * Abre Cadastro/configuracao Código de Barras
   * @param prod 
   * @returns 
   */
  openCodbarPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    let title = 'Código de Barras Produto: ';
    const safeProd = prod || {};
    const codigo = safeProd?.codigo ?? 'NOVO';
    const descricao = safeProd?.descricao ?? 'Produto';
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoCodbarPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '40%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : undefined,
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: `${title}[ ${codigo} - ${descricao} ]`, payload: safeProd }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Movimentações
   * @param prod 
   * @returns 
   */
  openMovtoPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    let title = "Movimentações Produto: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoMovtoPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : undefined,
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + prod.codigo + " - " + prod.descricao + " ]", payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Tributação
   * @param prod 
   * @returns 
   */
  openTribPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    let title = "Tributação Produto: ";
    this.dialogRefTrib = this.dialog.open(ProdutoTribPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '60%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : 'auto',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: `${title} [ ${prod.codigo} - ${prod.descricao} ]`, payload: prod }
    });
    this.dialogRefTrib.afterClosed().subscribe(res => this.getProduto());
  }






  /**
   * Abre Preços
   * @param prod 
   * @returns 
   */
  openPrecoPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    let title = "PREÇOS PRODUTO: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoPrecoPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : undefined,
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + prod.codigo + " - " + prod.descricao + " ]", payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Codigo/Foto
   * @param prod 
   * @returns 
   */
  openImagesPopUp(prod: any = {}) {

    // if(this.verifyIsNotSaved(prod.value))return;
    let title = "Imagens/Foto Produto:";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoImagesPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : undefined,
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + prod.codigo + " - " + prod.descricao + " ]", payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }


  /**
   * Verifica se o produto foi salvo
   * @param prod 
   * @param showMessage 
   * @returns 
   */

  verifyIsNotSaved(prod: any, showMessage = true): boolean {
    console.log(`verifyIsNotSaved >>>>>> ${prod.id}`);
    var id = prod.id;
    if (id === undefined || id === null || id === 0) {
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: `Por favor, salve o Produto e tente novamente !!`,
            error: true
          }
        );
      }
      return true;
    }
    return false;
  }

  openAnexoUploadListPopUp(prod: any = {}) {
    console.log(prod?.id ?? -1);

    if (this.verifyIsNotSaved(prod)) return;
    let title = "Anexos: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoAnexoUploadListComponent, {
      width: this.layout.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100vh' : undefined,
      maxHeight: '100vh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + prod.codigo + " - " + prod.descricao + " ]", payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
      })
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }




}
